import { render, staticRenderFns } from "./groupcustomer.vue?vue&type=template&id=132ea5dc&scoped=true&"
import script from "./groupcustomer.vue?vue&type=script&lang=js&"
export * from "./groupcustomer.vue?vue&type=script&lang=js&"
import style0 from "./groupcustomer.vue?vue&type=style&index=0&id=132ea5dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ea5dc",
  null
  
)

export default component.exports